import React, { useState } from 'react';
import { LogInIcon, KeyRoundIcon, MailIcon, LockIcon, InfoIcon } from 'lucide-react';
export function MemberLoginSection() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  return <div className="flex-1 rounded-2xl p-8 md:p-10" style={{
    backgroundColor: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)'
  }} data-id="element-1864">
      <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{
      backgroundColor: 'rgba(200,168,75,0.15)'
    }} data-id="element-1865">
        <LogInIcon size={24} style={{
        color: '#c8a84b'
      }} data-id="element-1866" />
      </div>
      <h2 className="text-3xl md:text-4xl font-bold uppercase mb-3" style={{
      fontFamily: 'Oswald, sans-serif',
      color: '#ffffff'
    }} data-id="element-1867">
        Member Login
      </h2>
      <p className="text-sm mb-6" style={{
      color: '#a0b8a8',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-1868">
        Your email address is your Login ID. Membership renewal is available
        when you edit your profile.
      </p>

      <form onSubmit={e => e.preventDefault()} className="space-y-4" aria-label="Member login form" data-id="element-1869">
        <div data-id="element-1870">
          <label htmlFor="member-email" className="block text-xs font-semibold uppercase tracking-wider mb-1.5" style={{
          color: '#a0b8a8',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1871">
            Email Address
          </label>
          <div className="relative" data-id="element-1872">
            <MailIcon size={15} className="absolute left-3 top-1/2 -translate-y-1/2" style={{
            color: '#7a9a8a'
          }} data-id="element-1873" />
            <input id="member-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="w-full pl-9 pr-4 py-3 rounded-lg text-sm outline-none transition-all" style={{
            backgroundColor: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1874" />
          </div>
        </div>

        <div data-id="element-1875">
          <label htmlFor="member-password" className="block text-xs font-semibold uppercase tracking-wider mb-1.5" style={{
          color: '#a0b8a8',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1876">
            Password
          </label>
          <div className="relative" data-id="element-1877">
            <LockIcon size={15} className="absolute left-3 top-1/2 -translate-y-1/2" style={{
            color: '#7a9a8a'
          }} data-id="element-1878" />
            <input id="member-password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full pl-9 pr-4 py-3 rounded-lg text-sm outline-none transition-all" style={{
            backgroundColor: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1879" />
          </div>
        </div>

        <div className="flex gap-3 pt-1" data-id="element-1880">
          <button type="submit" className="flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
          backgroundColor: '#c8a84b',
          color: '#1a1a1a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1881">
            <LogInIcon size={15} data-id="element-1882" />
            Log In
          </button>
          <button type="button" className="flex items-center justify-center gap-1.5 px-4 py-3 rounded-lg text-sm font-medium border transition-all hover:bg-white/10" style={{
          borderColor: 'rgba(255,255,255,0.2)',
          color: '#a0b8a8',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1883">
            <KeyRoundIcon size={14} data-id="element-1884" />
            Find Pass
          </button>
        </div>
      </form>

      <div className="mt-5 flex items-start gap-2 p-3 rounded-lg" style={{
      backgroundColor: 'rgba(200,168,75,0.08)',
      border: '1px solid rgba(200,168,75,0.15)'
    }} data-id="element-1885">
        <InfoIcon size={14} className="flex-shrink-0 mt-0.5" style={{
        color: '#c8a84b'
      }} data-id="element-1886" />
        <p className="text-xs" style={{
        color: '#a0b8a8',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-1887">
          You can opt out of email announcements in your membership profile.
          FLSC uses your profile email as our primary communication method.
        </p>
      </div>
    </div>;
}